import * as yup from "yup";

export const createNotificationSchema = (v, t, isEditMode) => {
  return yup.object().shape({
    userName: v.string().required(),
    mobileNumber: v.string().required(),
    message: v.string().required(),
  });
};
